import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_goalgeous-hub/artifacts/ad5dhro0_Untitled%20design.png";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-brand-dark border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <img 
              src={LOGO_URL} 
              alt="Power Up Your Fitness" 
              className="h-20 w-auto"
            />
            <p className="text-brand-gray font-montserrat text-sm leading-relaxed">
              More than fitness. This is a movement. Building confident, powerful women through fitness, nutrition, and community.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-oswald text-lg uppercase tracking-wider text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'About', path: '/about' },
                { name: 'Power Up Your Fitness', path: '/power-up' },
                { name: 'GOALGEOUS University', path: '/goalgeous-university' },
                { name: 'Club Deuces', path: '/club-deuces' },
                { name: 'SHOCK THE BODY', path: '/shock-the-body' },
                { name: 'GOAL-TRITION', path: '/goal-trition' },
                { name: 'Accountability Chats', path: '/accountability-check' },
                { name: 'Instructors', path: '/instructors' },
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    data-testid={`footer-link-${link.path.replace('/', '') || 'home'}`}
                    className="text-brand-gray hover:text-brand-lime transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-oswald text-lg uppercase tracking-wider text-white mb-6">Services</h4>
            <ul className="space-y-3">
              {[
                { name: 'THE POWER ROOM', path: '/power-up' },
                { name: 'Personal Training', path: '/power-up' },
                { name: 'Assisted Stretching', path: '/club-deuces' },
                { name: 'Meal Plans', path: '/goal-trition' },
              ].map((link, idx) => (
                <li key={idx}>
                  <Link 
                    to={link.path}
                    className="text-brand-gray hover:text-brand-pink transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-oswald text-lg uppercase tracking-wider text-white mb-6">Connect</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-brand-gray text-sm">
                <Mail size={18} className="text-brand-lime" />
                <span>powerupyourfitness@gmail.com</span>
              </li>
              <li className="flex items-center gap-3 text-brand-gray text-sm">
                <Phone size={18} className="text-brand-pink" />
                <span>(708) 803-2931</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-10 h-10 rounded-full bg-brand-subtle flex items-center justify-center text-white hover:bg-brand-pink hover:text-white transition-all"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="w-10 h-10 rounded-full bg-brand-subtle flex items-center justify-center text-white hover:bg-brand-lime hover:text-brand-black transition-all"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-brand-gray text-xs">
            © 2025 Power Up Your Fitness. All rights reserved.
          </p>
          <p className="text-brand-gray text-xs">
            <span className="text-brand-lime">2000 WATTS</span> • <span className="text-brand-pink">GOALGEOUS</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
